<template>
  <div class="tags" v-if="!editing">
    <a v-if="edit!==false" class="edit" v-on:click.prevent="editing=true">Edit</a>
    tags: 
    <template v-for="(tag, ti in activeTags">
      <a>{{ tag }}</a>{{ activeTags.length-1>ti?", ":"" }}
    </template>
  </div>
  <div class="tag-edit" v-else>
    <a class="edit" v-on:click.prevent="editing=false">Edit</a>
    <h3>Select Tags</h3>
    <ul class="tabs">
      <li v-for="(typeData, type) in types" :class="{active: currentTab==type}" v-on:click.prevent="currentTab=type" >
        {{ typeData.label }}
      </li>
    </ul>
    <ul class="items" v-if="types[currentTab]">
      <li v-for="(item, ii) in types[currentTab].items" v-on:click.prevent="toggleItem(currentTab, item.id)" :class="{active: isActive(currentTab, item.id)}">
        {{ item.title }}
      </li>
    </ul>
  </div>
</template>

<script>
import api from './api';

export default {
  props: ["item", "edit"],
  data: ()=>({
    editing: false,
    currentTab: "pace",
    types: {
//       pace: {label: "Theme", items: []},
      level: {label: "Level", items: []},
      speciality: {label: "Speciality", items: []},
      aparatus: {label: "Aparatus", items: []},
      prop: {label: "Props", items: []},
      part: {label: "Parts", items: []},
    },
  }),
  created() {
    this.loadOpts();
  },
  computed: {
    activeTags() {
      var result=[];
      var fields=[/*"pace", */"level", "speciality", "aparatus", "prop", "part"];
      for(var field of fields)
        for(var item of this.types[field].items)
          if (this.isActive(field, item.id))
            result.push(item.title);
      return result;
    },
  },
  methods: {
    async loadOpts() {
      var loads=[
        api.list("VideoAparatus", {}),
        api.list("VideoLevel", {}),
        api.list("VideoPace", {}),
        api.list("VideoProp", {}),
        api.list("VideoSpeciality", {}),
        api.list("VideoPart", {})];
      var results=await Promise.all(loads);
      var sortAZ=(a,b)=>{
        if (a.title<b.title) return -1;
        if (a.title>b.title) return 1;
      };
      this.types.aparatus.items=results[0].items.sort(sortAZ);
      this.types.level.items=results[1].items.sort(sortAZ);
//       this.types.pace.items=results[2].items.sort(sortAZ);
      this.types.prop.items=results[3].items.sort(sortAZ);
      this.types.speciality.items=results[4].items.sort(sortAZ);
      this.types.part.items=results[5].items.sort(sortAZ);
    },
    toggleItem(type, id) {
      if (!this.item)
        return false;
      var active=(this.item[type] || "").split(",").filter((a)=>a);
      if (active.indexOf(id)==-1)
        active.push(id);
      else
        active.splice(active.indexOf(id), 1);
      this.$set(this.item, type, active.join(","));
    },
    isActive(type, id) {
      if (!this.item)
        return false;
      var active=(this.item[type] || "").split(",").filter((a)=>a);
      return active.indexOf(id)!=-1;
    },
  },
};
</script>
